import React, { useEffect, useState } from 'react';
import { useHistory, generatePath } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAt,
  faMapMarkerAlt,
  faPhoneAlt,
  faUserGraduate,
  faCalendarAlt,
  faCoin,
  faUser,
  faBuilding,
} from '@fortawesome/pro-light-svg-icons';
import { Checkbox } from 'antd';
import moment from 'moment';
import { injectIntl } from 'react-intl';
import { useBreakpoint } from '../../../../hooks/useBreakpoint';
import { ROUTE_PACIENTES_WATCH } from '../../../../routes.constants';
import Notas from '../notas/notas';
import { setPacienteNotas, getPhotoPaciente } from '../../../../state/actions/creators/pacientes.actioncreator';
import {Box, ShowIf} from '../../../shared/components';

function PersonalData({ intl }:any) {
  const history = useHistory();
  const dispatch = useDispatch();
  const pacienteSelected = useSelector((state: any) => state.pacientesWorkspace.pacienteSelected);
  const notas = useSelector((state: any) => state.pacientesWorkspace.notas);
  const fotoPerfil = useSelector((state: any) => state.pacientesWorkspace.imagen);
  const loadingPhotos = useSelector((state:any) => state.pacientesWorkspace.loadingPhotos);
  const [perfilSource, setPerfilSource] = useState('');
  const lgWidth = useBreakpoint();

  // useEffect(() => {
  //   dispatch(getPhotoPaciente({
  //     pacienteId: parseInt(pacienteSelected.id, 10),
  //   }));
  // },[]);

  useEffect(() =>{
    if(fotoPerfil != '' ){
      setPerfilSource(fotoPerfil);
    }
  }, [fotoPerfil]);

  const setNotas = (notas: string) => {
    dispatch(setPacienteNotas({ pacienteId: pacienteSelected.id, texto: notas }));
  };
  if (!pacienteSelected) return null;
  const removeSinValor = (value: any) => {
    if (value === '<SIN VALOR>') return '';
    return value;
  };
  return (
    <>
      <div className="card">
        {lgWidth.isDesktop && (pacienteSelected.genero != 'O' && pacienteSelected.es_empresa === false ) && !loadingPhotos ? (
          <img
            className="avatar"
            src={pacienteSelected.genero == 'M' ? '/img/pacientes/Female.svg'
              : (pacienteSelected.genero == 'H' ? '/img/pacientes/Male.svg'  
              : `data:image/jpeg;base64,${perfilSource}`)}
            style={{width:"72px", height:"72px", borderRadius: '50%' }}
            alt="avatar"
          />
        ) : (
          <></>
        )}
        {lgWidth.isDesktop && (pacienteSelected.es_empresa === true) ? (
          <>
            <FontAwesomeIcon icon={faBuilding} style={{width:"72px", height:"72px", borderRadius: '50%', color:'white', backgroundColor: '#444963', padding: '10px'}} />
            <br/><br/>
          </>
        ) : (
          <></>
        )}
        {lgWidth.isDesktop && (pacienteSelected.genero == 'O') ? (
        <>
          <FontAwesomeIcon icon={faUser} style={{width:"72px", height:"72px", borderRadius: '50%', color:'white', backgroundColor: '#444963', padding: '10px'}} />
          <br/><br/>
        </>
        ) : (
          <></>
        )}
        <div className="flexRow spaceBetween fullWidth">
          <h3 className="title">{intl.formatMessage({ id: 'pacientes.personal_data.basic_info' })}</h3>
          <p
            className="mail"
            onClick={() => history.push(generatePath(ROUTE_PACIENTES_WATCH,
              { pacienteId: pacienteSelected.id }))}
          >
            {intl.formatMessage({ id: 'pacientes.personal_data.see_file' })}
          </p>
        </div>
        <div className="inTopCard">
          <div className="left fullWidth">
            <ShowIf condition={pacienteSelected.email}>
              <div className="rowPData">
                <FontAwesomeIcon className="icons" icon={faAt} />
                <p className="mail">{removeSinValor(pacienteSelected.email)}</p>
              </div>
            </ShowIf>
            <ShowIf condition={pacienteSelected.direccion}>

              <div className="rowPData">
                <FontAwesomeIcon className="icons" icon={faMapMarkerAlt} />
                <p>{pacienteSelected.direccion ? removeSinValor(pacienteSelected.direccion) : ''}</p>
              </div>
            </ShowIf>
            <ShowIf condition={pacienteSelected.telefono_1 || pacienteSelected.telefono_2}>
              <div className="rowPData">
                <FontAwesomeIcon className="icons" icon={faPhoneAlt} />
                <div>
                  <Box>{pacienteSelected.telefono_1 && <p>{removeSinValor(pacienteSelected.telefono_1)}</p>}</Box>
                  <Box mt="4px">{pacienteSelected.telefono_2 && <p>{removeSinValor(pacienteSelected.telefono_2)}</p>}</Box>
                </div>
              </div>
            </ShowIf>
            <ShowIf condition={pacienteSelected.str_profesion}>
              <div className="rowPData">
                <FontAwesomeIcon className="icons" icon={faUserGraduate} />
                <p>{removeSinValor(pacienteSelected.str_profesion)}</p>
              </div>
            </ShowIf>
            <ShowIf condition={pacienteSelected.fecha_nacimiento}>
              <div className="rowPData">
                <FontAwesomeIcon className="icons" icon={faCalendarAlt} />
                <p>
                  {moment().diff(moment(pacienteSelected.fecha_nacimiento.split(' ')[0], 'DD-MM-YYYY'), 'years')}
                  {' '}
                  {intl.formatMessage({ id: 'pacientes.personal_data.years' })}
                </p>
              </div>
            </ShowIf>
          </div>
          {lgWidth.isTablet && (pacienteSelected.genero != 'O' && pacienteSelected.es_empresa === false ) && !loadingPhotos? (
            <img
              className="avatar"
              src={pacienteSelected.genero == 'M' ? '/img/pacientes/Female.svg'
                : (pacienteSelected.genero == 'H' ? '/img/pacientes/Male.svg'  
                : `data:image/jpeg;base64,${perfilSource}`)}
              style={{width:"72px", height:"72px", borderRadius: '50%' }}
              alt="avatar"
            />
          ) : (
            <></>
          )}
          {lgWidth.isTablet && (pacienteSelected.es_empresa === true) ? (
            <>
              <FontAwesomeIcon icon={faBuilding} style={{width:"72px", height:"72px", borderRadius: '50%', color:'white', backgroundColor: '#444963', padding: '10px', marginBottom:'8px'}} />
            </>
          ) : (
            <></>
          )}
          {lgWidth.isTablet && (pacienteSelected.genero == 'O') ? (
            <>
              <FontAwesomeIcon icon={faUser} style={{width:"72px", height:"72px", borderRadius: '50%', color:'white', backgroundColor: '#444963', padding: '10px', marginBottom:'8px'}} />
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className="card">
        <h3 className="title" style={{ marginTop: 16 }}>{intl.formatMessage({ id: 'pacientes.client_file.gdpr' })}</h3>
        <div className="rowPData">
          <div className="flexCol">
            <div className="flexRow">
              <Checkbox disabled checked={pacienteSelected.rgpd_firmada === true ?? false} />
              <p>{intl.formatMessage({ id: 'pacientes.client_file.gdpr' })}</p>
            </div>
            {pacienteSelected.rgpd_fecha_inactivo
              ? (
                <>
                  <p className="errors" style={{ marginLeft: 0 }}>
                    {intl.formatMessage({ id: 'pacientes.personal_data.must_sign_actual_gdpr' })}
                  </p>
                </>
              )
              : <></>
            }
          </div>
        </div>
        <div className="rowPData">
          <Checkbox disabled checked={pacienteSelected.rgpd_com_comerciales === true ?? false} />
          <p>{intl.formatMessage({ id: 'pacientes.personal_data.commercial_communications' })}</p>
        </div>
      </div>
      <div className="card">
        <h3 className="title" style={{ marginTop: 16 }}>Marketing</h3>
        <div className="rowPData">
          <Checkbox disabled checked={pacienteSelected.enviar_mailing === true ?? false} />
          <p>Mailing</p>
        </div>
        <div className="rowPData">
          <Checkbox disabled checked={pacienteSelected.enviar_sms === true ?? false} />
          <p>SMS</p>
        </div>
        <div className="rowPData">
          <Checkbox disabled checked={pacienteSelected.enviar_email === true ?? false} />
          <p>Emails</p>
        </div>
      </div>
      <div className="lastCard">
        <h3 className="title" style={{ marginTop: 16 }}>
          {intl.formatMessage({ id: 'pacientes.personal_data.points' })}
        </h3>
        <div className="rowPData">
          <FontAwesomeIcon className="icons" icon={faCoin} />
          <p>0</p>
        </div>
      </div>
      {false
      && (
      <div className="lastCard">
        <Notas disabled={false} notas={notas} setNotas={setNotas} />
      </div>
      )
      }
    </>
  );
}

export default injectIntl(PersonalData);
